/* unplugin-vue-components disabled */import { ElSelect as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiGsPlayerOrderList } from '@/api/gsManage';
export default /*#__PURE__*/_defineComponent({
  __name: 'gsEarning',
  props: {
    gameId: {
      type: Number,
      default: undefined
    },
    currencyList: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;
    const currentCurrency = ref('USD');
    const activeKey = ref('gsEarning');
    const panes = ref([{
      title: 'GS收益报表',
      key: 'gsEarning'
    }]);
    const columns = [{
      label: 'GS名称',
      prop: 'name'
    }, {
      label: '绑定角色数',
      prop: 'player_count'
    }, {
      label: '分成比例',
      prop: 'rate',
      slot: 'rate'
    }, {
      label: '总收益',
      prop: 'charge_amount_rate'
    }, {
      label: '当月收益',
      prop: 'month_income_amount'
    }, {
      label: '当日收益',
      prop: 'today_income_amount'
    }];
    const getTableData = async () => {
      tableLoading.value = true;
      const res = await apiGsPlayerOrderList({
        is_over_view: 1,
        current_page: current.value,
        page_size: pageSize.value,
        game_id: props.gameId,
        currency: currentCurrency.value
      });
      tableLoading.value = false;
      if (res.code === 0) {
        tableData.value = res.data;
        total.value = res.meta && res.meta.pagination && res.meta.pagination.total || 0;
      }
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    watch(() => props.gameId, val => {
      if (val) getTableData();
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_option = __unplugin_components_0;
      const _component_el_select = __unplugin_components_1;
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createBlock(_component_u_card, {
        modelValue: _unref(activeKey),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(activeKey) ? activeKey.value = $event : null),
        panes: _unref(panes),
        class: "margin-pane"
      }, {
        extra: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _unref(currentCurrency),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(currentCurrency) ? currentCurrency.value = $event : null),
          style: {
            "width": "160px"
          },
          onChange: getTableData
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.currencyList, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.currency
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        default: _withCtx(() => [_createVNode(UTable, {
          loading: _unref(tableLoading),
          "row-key": "id",
          options: columns,
          data: _unref(tableData),
          total: _unref(total),
          pagination: "",
          onSizeChange: _unref(handleSizeChange),
          onCurrentChange: _unref(handleCurrentChange)
        }, {
          rate: _withCtx(({
            scope
          }) => [_createTextVNode(_toDisplayString(scope.row.rate ? scope.row.rate / 100 + '%' : '-'), 1)]),
          _: 1
        }, 8, ["loading", "data", "total", "onSizeChange", "onCurrentChange"])]),
        _: 1
      }, 8, ["modelValue", "panes"]);
    };
  }
});